"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villanova-marchesana": {
    "5ac97877": [{
      "hkey": "d34ba8ff",
      "slug": "canalazzo-ponte-via-liberta",
      "name": "Canalazzo-Ponte-Via Libertà",
      "primary": true,
      "skipSearch": false
    }],
    "canalazzo": [{
      "hkey": "d34ba8ff",
      "slug": "canalazzo-ponte-via-liberta",
      "name": "Canalazzo-Ponte-Via Libertà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f8e32ce8": [{
      "hkey": "d34ba8ff",
      "slug": "canalazzo-ponte-via-liberta",
      "name": "Canalazzo-Ponte-Via Libertà",
      "primary": true,
      "skipSearch": false
    }],
    "ponte": [{
      "hkey": "d34ba8ff",
      "slug": "canalazzo-ponte-via-liberta",
      "name": "Canalazzo-Ponte-Via Libertà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villanova-marchesana"
    }]
  }
};
exports["default"] = _default;